module.exports = __webpack_public_path__ + "static/media/kanga-bg.6206d371.png";